"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = defaultFetch;

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

function defaultFetch(path, data) {
  return _apiClient.default.post(path, {
    data: data
  });
}

module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-avatars/static-2.2401/js/api/defaultFetchAvatars.js
// module id = 417
// module chunks = 209 210 211 212